// Login.js

import React, { useMemo, useState } from 'react';
import { useEffect } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Loader } from '../../components/loader';
import { useGroupChatContext } from '../../context/groupchatContext';
import { chatLogin, verifyPin } from '../../services/login';

const PinCodeCard = ({phone}) => {

    const [processing, setProcessing] = useState('');
    const [pinCode, setPinCode] = useState(['', '', '', '', '']);

    const navigate = useNavigate();
    const groupChatContext = useGroupChatContext();
    const {setAuthData, setIsShowPinCreateScreenOnFirstLogin, setIsOpenChangePinCodePopup} = useMemo(() => ({
        setAuthData: groupChatContext.setAuthData,
        setIsShowPinCreateScreenOnFirstLogin: groupChatContext.setIsShowPinCreateScreenOnFirstLogin,
        setIsOpenChangePinCodePopup: groupChatContext.setIsOpenChangePinCodePopup,

    }));

    const focusNextInput = (index) => {
        if(index < 4){
            document.getElementById(`pinInput${index + 1}`).focus();
        }
    }

    const focusPrevInput = (index) => {
        if(index > 0){
            document.getElementById(`pinInput${index - 1}`).focus();
        }
    }

    const handleInputChange = (index, value) => {
        if(value.length === 1 && index < 4) {
            focusNextInput(index)
        }
    
        // Update the pin code state
        const newPinCode = [...pinCode];
        newPinCode[index] = value;
        setPinCode(newPinCode);
    };

    useEffect(()=>{
        const pin = pinCode.join('');
        if(pin?.length === 5){
            verifyPinCode()
        }
    }, [pinCode])

    const verifyPinCode = () => {
        const payload = {phone, pincode: pinCode.join(''), isJoinForm: true}
        setProcessing('verify_code')
        verifyPin(payload).then((res) => {
            setProcessing('')
            if(res?.data?.response.code == 0){
                localStorage.setItem('auth', JSON.stringify(res?.data?.response.data));
                if(res?.data?.response.data.pincode_update_required == true){
                    setIsShowPinCreateScreenOnFirstLogin(true);
                    localStorage.setItem('createPinOnFirstLogin', true);
                    setIsOpenChangePinCodePopup(true);
                }
                setAuthData(res?.data?.response.data);
                setTimeout(()=>{
                    navigate('/')
                }, 1000)
            }
            else {
                toast.error(res?.data?.response?.msg);
            }
        });
    }

    const handleResendCode = () => {
        setProcessing('resend_code');
        chatLogin({phone, isJoinForm: true}).then((res) => {
            setProcessing('');
            if(res?.data?.response.code == 0){
                setPinCode(['', '', '', '', '']);
                toast.success(res?.data?.response?.msg);
            }
            else {
                toast.error(res?.data?.response?.msg);
            }
        });
    };

    const handleOnKeyDown = (index, e) => {
        const pressedKey = e.key;
        switch (pressedKey) {
            case "Backspace":
            case "Delete": {
                e.preventDefault();

                const newPinCode = [...pinCode];
                if(newPinCode[index]) {
                    newPinCode[index] = '';
                    setPinCode(newPinCode);
                }

                focusPrevInput(index);
                break;
            }
            case "ArrowLeft": {
                e.preventDefault();
                focusPrevInput(index);
                break;
            }
            case "ArrowRight": {
                e.preventDefault();
                focusNextInput(index);
                break;
            }
            default: {
                if (pressedKey.match(/^[^a-zA-Z0-9]$/)) {
                    e.preventDefault();
                }
                else{
                    const newPinCode = [...pinCode];
                    if(newPinCode[index]) {
                        newPinCode[index] = pressedKey;
                        setPinCode(newPinCode);
                        // focusNextInput(index);
                    }
                }

                break;
            }
        }
    }


    return (
        <>
            <div className="max-w-xs mx-auto p-6 bg-white rounded-lg shadow-md">
                {(processing == 'verify_code' ) && (
                    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none before:absolute before:flex before:bg-black/25 before:w-full before:h-full z-[999]">
                        <Loader />
                    </div>
                )}
                <h2 className="text-2xl font-semibold mb-4 text-gray-500">Enter PIN Code</h2>
                <div className="flex items-center justify-center space-x-4">
                    {pinCode.map((digit, index) => (
                        <input
                            key={index}
                            type="text"
                            id={`pinInput${index}`}
                            value={digit}
                            maxLength={1}
                            onChange={(e) => handleInputChange(index, e.target.value)}
                            onKeyDown={(e) => handleOnKeyDown(index, e)}
                            autoComplete="off"
                            className="w-12 h-12 text-2xl text-center border rounded focus:outline-none focus:border-blue-500"
                        />
                    ))}
                </div>
                <div className='mt-2 flex'>
                    <a className="text-base font-light text-blue-600 cursor-pointer black-39 hover:underline my-2"
                        onClick={handleResendCode}>
                        Resend Code
                    </a>
                    {processing == 'resend_code' ? <FaSpinner className="animate-spin text-green-300-500 ml-1 mt-[0.6rem] text-blue-600" size={20} /> : ''}
                </div>
            </div>
        </>
    );
};

export default PinCodeCard;
